// extracted by mini-css-extract-plugin
export default {"container":"ReceivedCostCard_container__JwbvM","item":"ReceivedCostCard_item__a8r3h"};